import React from "react";
import "./Card.css";

export const ProductDescription = () => {
  return (
    <div id="product-description">
      A floral, solar and voluptuous interpretation composed by Olivier Polge,
      Perfumer-Creator for the House of CHANEL.
    </div>
  );
};
